import { Navigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "context/AuthContext";
import { ROLES } from "utils/constants";
import { ROUTES } from "utils/routes";

/** Host ("Real Customer") only. Everyone else is sent to their home page. */
const UserRoute = ({ children }) => {
  const { user, loggedIn } = useContext(AuthContext);
  if (!user || !loggedIn || user.role !== ROLES.HOST.role) {
    return <Navigate to={ROUTES.WELCOME} replace />;
  }
  return children;
};

export default UserRoute;
